import { Component, inject } from '@angular/core';
import { TractorCategoryService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TractorCategoryCreateDto,
  TractorCategoryDto,
  TractorCategoryExcelDownloadDto,
  TractorCategoryUpdateDto,
} from '../proxy/general/dtos/tractor-category';
import { TRACTORCATEGORY_CONFIG, TRACTORCATEGORY_FIELDS } from './tractor-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tractor-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TractorCategoryService, ConfirmationService],
  templateUrl: './tractor-category.html',
  styleUrl: './tractor-category.scss',
})
export class TractorCategory extends BaseCrudComponent<
  TractorCategoryDto,
  TractorCategoryCreateDto,
  TractorCategoryUpdateDto,
  TractorCategoryExcelDownloadDto
> {
  service = inject(TractorCategoryService);
  config = TRACTORCATEGORY_CONFIG;
  fields = TRACTORCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractorCategoryDto): TractorCategoryUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TractorCategory';
  }
}
